import React from 'react'
import axios from 'axios'
import { IconButton, LinearProgress } from '@material-ui/core'
import { AddAPhoto } from '@material-ui/icons'

const AreaPhotoUploader = ({ areaId, url, onPhotoAdded }) => {
  const inputRef = React.useRef(null)
  const [uploading, setUploading] = React.useState(false)
  const [progress, setProgress] = React.useState(0)

  const handleFileSelect = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const formData = new FormData()
    formData.append('file', file)

    setUploading(true)
    setProgress(0)

    axios.post(`${url}/api/bid-estimation/areas/${areaId}/photos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (e.total) setProgress(Math.round((e.loaded / e.total) * 100))
      }
    }).then(res => {
      setUploading(false)
      if (onPhotoAdded) onPhotoAdded(res.data)
      if (inputRef.current) inputRef.current.value = ''
    }).catch(err => {
      setUploading(false)
      console.error('Photo upload failed:', err)
      if (inputRef.current) inputRef.current.value = ''
    })
  }

  return (
    <div style={{ display: 'inline-block' }}>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
      <IconButton size="small" onClick={() => inputRef.current?.click()} disabled={uploading} title="Add Photo">
        <AddAPhoto fontSize="small" />
      </IconButton>
      {uploading && <LinearProgress variant="determinate" value={progress} style={{ width: 60, marginTop: 2 }} />}
    </div>
  )
}

export default AreaPhotoUploader
